import React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, msalInitPromise } from "./auth/msalClient";
import App from "./components/App";
import { store } from './store';
import { Provider } from 'react-redux';
import { FluentProvider, teamsLightTheme } from '@fluentui/react-components';
import { BrowserRouter } from "react-router-dom";
import "./styles/index.css";
import { errorDev } from '@/logging/devConsole';

// Wait for MSAL to initialize before mounting the React app
msalInitPromise.then(() => {
  const rootElement = document.getElementById("root");
  if (!rootElement) throw new Error("Root element not found");
  const root = createRoot(rootElement);
  
  const app = (
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <FluentProvider theme={teamsLightTheme}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </FluentProvider>
      </MsalProvider>
    </Provider>
  );
  
  root.render(
    import.meta.env.DEV ? <React.StrictMode>{app}</React.StrictMode> : app
  );
}).catch(error => {
  errorDev("MSAL initialization failed:", error);
});